module.exports = __webpack_public_path__ + "static/new_sloth_500-9987976114016c734877ee865ffd2ca8.png";